// ======================================================================
// File Name       : ScoringReportModalHeader
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Form, InputGroup, Col, Button } from 'react-bootstrap';
import RenderField from '../../../utils/ReduxFormUtils';
import * as ReportConstants from '../../../constants/ScoringReportConstants';
import {
  DEFAULT_DATE_TO_TEXT,
  DEFAULT_DATE_FROM_TEXT,
  DEFAULT_DATE_FORMAT,
} from '../../../constants/index';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../../constants/AuthorityConstant';
import { parseDateForDetail } from '../../../utils/index';

class ReportModalHeader extends Component {
  render() {
    const {
      itemLearningHistoryReportIdAuto,
      reportDeadline,
      reportReturnPlanDate,
      reportName,
      enableApprovalButton,
      enableCollectButton,
      enableCorrectButton,
      enableFinishSaveButton,
      enableReasonButton,
      enableRemandButton,
      enableWithDrawalButton,
      enableSaveButton,
      reportComment,
      scoringManagementAuthority,
      reportStatus,
      drillHistoryInfo,
    } = this.props;
    const reportDeadlineTemp = parseDateForDetail(reportDeadline, DEFAULT_DATE_FORMAT, DEFAULT_DATE_TO_TEXT);
    const reportReturnPlanDateTemp = parseDateForDetail(reportReturnPlanDate, DEFAULT_DATE_FORMAT, DEFAULT_DATE_FROM_TEXT);
    const drillResultExp = drillHistoryInfo && drillHistoryInfo.drillResultExp ? drillHistoryInfo.drillResultExp : 0;
    const drillResultNum = drillHistoryInfo && drillHistoryInfo.drillResultNum ? drillHistoryInfo.drillResultNum : 0;
    const questionCount = drillHistoryInfo && drillHistoryInfo.questionCount ? drillHistoryInfo.questionCount : 0;
    const perfectPoint = drillHistoryInfo && drillHistoryInfo.perfectPoint ? drillHistoryInfo.perfectPoint : 0;
    let result = '0';
    if (drillResultExp === 0) {
      result = `${drillResultNum}問/${questionCount}問`
    } else if (drillResultExp === 1) {
      result = `${drillResultNum}%`
    } else if (drillResultExp === 2) {
      result = `${drillResultNum}点/${perfectPoint}点`
    }
    return (
      <div>
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              添削管理ID:
            </Col>
            <Col sm={3} as={Form.Label}>
              {itemLearningHistoryReportIdAuto}
            </Col>
            <Col sm={6} as={Form.Label}>
              成績: {result}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              提出期限:
            </Col>
            {/* #7232 START */}
            <Col sm={3} as={Form.Label}>
              {reportDeadlineTemp}
            </Col>
            <Col id="drillViewPoint" sm={6} as={Form.Label} />
            {/* #7232 END */}
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              結果返却予定日:
            </Col>
            <Col sm={9} as={Form.Label}>
              {reportReturnPlanDateTemp}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              レポート名:
            </Col>
            <Col sm={9} as={Form.Label}>
              {reportName}
            </Col>
          </Form.Group>
        </Form>
        {/* show only when scoringManagementAuthority = 2 (full scoring authority) */}
        {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT ?
          <Form.Group>
            <Col sm={12} className="margin-top-20">
              <Button
                variant="warning"
                className="btn-96 margin-left-15"
                disabled={!enableApprovalButton}
                onClick={this.props.openApprovalConfirmDialog}
              >
                {ReportConstants.Label_Approval}
              </Button>
              <Button
                variant="danger"
                className="btn-96 margin-left-15"
                disabled={!enableRemandButton}
                onClick={this.props.openRemandInputDialog}
              >
                {ReportConstants.Label_Remand}
              </Button>
              <Button
                variant="danger"
                className="btn-96 margin-left-15"
                disabled={!enableCollectButton}
                onClick={this.props.openCollectConfirmDialog}
              >
                {ReportConstants.Label_Collect}
              </Button>
            </Col>
          </Form.Group> : null}
        {scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE &&
          (reportStatus === ReportConstants.REPORT_STATUS_ID.APPPROVED ||
          reportStatus === ReportConstants.REPORT_STATUS_ID.RESULT_RETURN) ? null :
          <Form.Group>
            <Col sm={12} className="margin-top-10">
              <Button
                variant="primary"
                className="btn-96 margin-left-15"
                disabled={!enableCorrectButton}
                onClick={this.props.onEnableFinishSaveButton}
              >
                {ReportConstants.Label_Correct}
              </Button>
              <Button
                variant="primary"
                className="btn-96 margin-left-15"
                disabled={!enableWithDrawalButton}
                onClick={this.props.openWithDrawalDialog}
              >
                {ReportConstants.Label_WithDrawal}
              </Button>
              <Button
                variant="primary"
                className="btn-96 margin-left-15"
                disabled={!enableReasonButton}
                onClick={this.props.openReasonInputDialog}
              >
                {ReportConstants.Label_Reason}
              </Button>
              <Button
                variant="primary"
                className="btn-96 margin-left-15"
                disabled={!enableFinishSaveButton}
                onClick={this.props.openFinishConfirmDialog}
              >
                {ReportConstants.Label_Finish}
              </Button>
              <Button
                variant="primary"
                className="btn-96 margin-left-15"
                disabled={!enableSaveButton}
                onClick={this.props.openSaveDialog}
              >
                {ReportConstants.Label_Save}
              </Button>
            </Col>
          </Form.Group>}
        <Form.Group>
          <Col sm={12} className="margin-top-10">
            <Col sm={12}>
              <RenderField
                type="textarea"
                name="reportComment"
                value={reportComment}
                readOnly={!enableFinishSaveButton}
                className="borderSolid0pxHalf textColorRed"
                maxLength={2048}
              />
            </Col>
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default ReportModalHeader;
